import React from 'react';
import { View } from 'react-native';
import { SortingType } from './PortfolioHoldingsTable';
import { useAppLanguage } from '@altify/utils';
import { DialogOrBottomSheet } from 'components/DialogOrBottomSheet/DialogOrBottomSheet';
import { Heading, RadioButton, Typography } from '@altify/components';
import Tabs from 'components/Tabs/Tabs';
import { portfolioFilteringOptions } from './portfolioFilterOptions';

export function PortfolioSortingModal({
  isOpen,
  onClose,
  sorting,
  setSorting,
}: {
  isOpen: boolean;
  onClose: () => void;
  sorting: SortingType;
  setSorting: (sorting: SortingType) => void;
}) {
  const language = useAppLanguage();
  const activeIndex = portfolioFilteringOptions.findIndex(
    option => option.value === sorting,
  );
  const items = portfolioFilteringOptions.map(option => ({
    label: option.label[language],
    value: option.value,
  }));
  return (
    <DialogOrBottomSheet isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col px-4 pb-8 gap-8">
        <Heading level={4}>View</Heading>
        <div className="flex whitespace-nowrap w-full overflow-x-auto no-scrollbar">
          {items?.map((item, i) => (
            <RadioButton
              key={i}
              selected={activeIndex === i}
              className="px-2 mx-1 rounded-md"
              title={item?.label}
              onPress={() => setSorting(item.value)}
            />
          ))}
        </div>
      </div>
    </DialogOrBottomSheet>
  );
}
